import _ from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import MenusGql from '@/store/graphql/cms/queries/Menus.gql';
import MenuGql from '@/store/graphql/cms/queries/Menu.gql';

import MenusPaginatedGql from '@/store/graphql/cms/queries/MenusPaginated.gql';

import CreateMenuGql from '@/store/graphql/cms/mutations/CreateMenu.gql';
import UpdateMenuGql from '@/store/graphql/cms/mutations/UpdateMenu.gql';
import DeleteMenuGql from '@/store/graphql/cms/mutations/DeleteMenu.gql';

import TranslateMenuItemGql from '@/store/graphql/cms/mutations/TranslateMenuItem.gql';
import CloneMenuItemGql from '@/store/graphql/cms/mutations/CloneMenuItem.gql';

import MenuKeysGql from '@/store/graphql/cms/queries/MenuKeys.gql';
import MenuItemGql from '@/store/graphql/cms/queries/MenuItem.gql';
import MenuItemPathsGql from '@/store/graphql/cms/queries/MenuItemPaths.gql';

export default {
    fetchList: (cmsID = null) =>
        new Promise((resolve, reject) => {
            let variables = {};
            if (cmsID) variables.cms = parseInt(cmsID);

            apolloClient
                .query({
                    query: MenusGql,
                    variables
                })
                .then(({ data }) => resolve(data.CP_Menus))
                .catch(err => reject(err));
        }),
    // fetchMenusPaginated: data =>
    //     new Promise((resolve, reject) => {
    //         let filters = [];
    //         _.each(data.filters, entry => filters.push(entry));

    //         apolloClient
    //             .query({
    //                 query: MenusPaginatedGql,
    //                 variables: {
    //                     currentPage: _.get(data, 'pageInfo.currentPage', 1),
    //                     perPage: _.get(data, 'pageInfo.perPage', 25),
    //                     order: _.get(data, 'variables.order', 'id'),
    //                     direction: _.get(data, 'variables.direction', 'asc'),
    //                     filters
    //                 }
    //             })
    //             .then(({ data }) => resolve(data))
    //             .catch(err => reject(err));
    //     }),
    fetchMenu: (key, cms) => {
        if (key === undefined || cms === undefined) throw new Error('required argument is missing');

        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: MenuGql,
                    variables: { key, cms: parseInt(cms) }
                })
                .then(({ data }) => resolve(data.CP_Menu))
                .catch(err => reject(err));
        });
    },
    fetchKeys: excludedID =>
        new Promise((resolve, reject) => {
            let variables = {};
            if (excludedID) variables.excludedID = parseInt(excludedID);

            apolloClient
                .query({
                    query: MenuKeysGql,
                    variables
                })
                .then(({ data }) => resolve(data.CP_Menus))
                .catch(err => reject(err));
        }),
    fetchItem: id =>
        new Promise((resolve, reject) => {
            let variables = {};
            if (id) variables.id = parseInt(id);

            apolloClient
                .query({
                    query: MenuItemGql,
                    variables
                })
                .then(({ data }) => resolve(data.CP_MenuItem))
                .catch(err => reject(err));
        }),
    fetchTranslation: id =>
        new Promise((resolve, reject) => {
            let variables = { translation: true };
            if (id) variables.id = parseInt(id);

            apolloClient
                .query({
                    query: MenuItemGql,
                    variables
                })
                .then(({ data }) => resolve(data.CP_MenuItem))
                .catch(err => reject(err));
        }),
    fetchItemPaths: (cmsID = null, excludedMenuKey = null) =>
        new Promise((resolve, reject) => {
            let variables = {};
            if (excludedMenuKey) variables.excludedMenuKey = excludedMenuKey;
            if (cmsID) variables.cms = parseInt(cmsID);

            apolloClient
                .query({
                    query: MenuItemPathsGql,
                    variables
                })
                .then(({ data }) => resolve(data.CP_MenuItems))
                .catch(err => reject(err));
        }),

    translateMenuItem: (menuItem, language, type = 'create-empty') => {
        if (menuItem === undefined) throw new Error('required argument is missing');
        if (language === undefined) throw new Error('required argument is missing');
        if (type === undefined) throw new Error('required argument is missing');

        menuItem = _.removeDeepByKey(menuItem, '__typename');
        language = _.removeDeepByKey(language, '__typename');

        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: TranslateMenuItemGql,
                    variables: { menuItem, language, type }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CP_TranslateMenuItem);
                })
                .catch(err => reject(err));
        });
    },
    cloneMenuItem: (variables) => {
        if (!variables || !variables.sourceMenuItemId || !variables.menuId) {
            throw new Error('required argument is missing');
        }

        variables = _.removeDeepByKey(variables, '__typename');
        variables = _.removeDeepByKey(variables, 'component');

        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CloneMenuItemGql,
                    variables
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CP_CloneMenuItem);
                })
                .catch(err => reject(err));
        });
    },
    create: menu => {
        if (menu === undefined) throw new Error('required argument is missing');

        menu = _.removeDeepByKey(menu, '__typename');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CreateMenuGql,
                    variables: { menu }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CP_CreateMenu);
                })
                .catch(err => reject(err));
        });
    },
    update: menu => {
        if (menu === undefined) throw new Error('required argument is missing');
        menu = _.removeDeepByKey(menu, '__typename');
        menu = _.removeDeepByKey(menu, 'fields');
        menu = _.removeDeepByKey(menu, 'remote');
        menu = _.removeDeepByKey(menu, 'request_type');
        menu = _.removeDeepByKey(menu, 'token');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UpdateMenuGql,
                    variables: { menu }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CP_UpdateMenu);
                })
                .catch(err => reject(err));
        });
    },
    delete: id => {
        if (id === undefined) throw new Error('required argument is missing');

        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DeleteMenuGql,
                    variables: { id: parseInt(id) }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CP_DeleteMenu);
                })
                .catch(err => reject(err));
        });
    },
    noDeleteDialog: (value) => {
        if (value !== undefined) {
            localStorage.setItem('no-delete-dialog:menu-item', value);
        } else {
            return localStorage.getItem('no-delete-dialog:menu-item');
        }
    }
};
